module.exports = __webpack_public_path__ + "img/pav.634b64bc.png";